import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import type { Product } from '../../types/product';
import { reveal } from '../../utils/motion';
type ProductCrossSellProps = {
  siblings: Product[];
};

/**
 * Closing band on every product page. Pointing at the other two products in
 * their own signature colours is what makes this read as one ecosystem rather
 * than three separate brochures.
 */
export function ProductCrossSell({
  siblings
}: ProductCrossSellProps) {
  const reduceMotion = useReducedMotion();
  return <section className="bg-ink px-5 py-24 text-paper md:px-10 md:py-32 lg:pl-20" aria-labelledby="cross-sell-heading" data-id="element-721" data-mp="3jdmgjc0xseat">
      <div className="mx-auto max-w-shell" data-id="element-722" data-mp="3ehyuh5hr419j">
        <p className="text-xs font-extrabold tracking-[0.16em] text-signal" data-id="element-723" data-mp="28025npvqjkld">
          THE REST OF THE PLATFORM
        </p>
        <h2 id="cross-sell-heading" className="mt-5 max-w-3xl font-display text-4xl font-bold leading-[0.9] md:text-6xl" data-id="element-724" data-mp="22z4dqlkxbc6o">
          One campaign infrastructure. Three ways in.
        </h2>

        <div className="mt-14 grid gap-4 md:grid-cols-2" data-id="element-725" data-mp="arek27de2o4t">
          {siblings.map((sibling, index) => <motion.article key={sibling.slug} {...reveal(reduceMotion, index)} data-id="element-726" data-mp="3t184ikr9myt0" data-mpi={index}>
              <Link to={sibling.path} className={`flex h-full flex-col p-7 transition-transform hover:-translate-y-1 md:p-9 ${sibling.theme.surface} ${sibling.theme.onSurface}`} data-id="element-727" data-mp="1qzkq43lb8ib">
                <p className={`text-xs font-extrabold tracking-[0.14em] ${sibling.theme.eyebrow}`} data-id="element-728" data-mp="3o1vczmpg93k3">
                  PRODUCT {sibling.number}
                </p>
                <h3 className="mt-10 font-display text-3xl font-bold leading-[0.95] md:text-4xl" data-id="element-729" data-mp="3e7v5xfalxo8q">
                  {sibling.name}
                </h3>
                <p className={`mt-5 max-w-sm leading-relaxed ${sibling.theme.onSurfaceMuted}`} data-id="element-730" data-mp="358808hauhw9v">
                  {sibling.summary}
                </p>
                <span className="mt-auto flex items-center gap-2 pt-10 text-sm font-extrabold" data-id="element-731" data-mp="162ci96zict62">
                  EXPLORE {sibling.shortName.toUpperCase()}
                  <ArrowUpRightIcon size={16} aria-hidden="true" data-id="element-732" data-mp="11ymrcavd1zhv" />
                </span>
              </Link>
            </motion.article>)}
        </div>

        <Link to="/platform" className="mt-10 inline-flex min-h-12 items-center gap-2 rounded-full bg-signal px-6 text-sm font-extrabold text-white transition-colors hover:bg-signal-dark active:bg-signal-darker" data-id="element-733" data-mp="1trn7psber14w">
          SEE HOW MEASUREMENT WORKS
          <ArrowUpRightIcon size={16} aria-hidden="true" data-id="element-734" data-mp="1frcggo66rkj7" />
        </Link>
      </div>
    </section>;
}